import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB_bcfbdIRcXnxfmTY-RW7d_AztcsbDYqg",
  authDomain: "fir-tripy-auth.firebaseapp.com",
  projectId: "fir-tripy-auth",
  storageBucket: "fir-tripy-auth.appspot.com",
  messagingSenderId: "709612611506",
  appId: "1:709612611506:web:205415f20e333f441ba6ab",
  measurementId: "G-KYHG3TBKDC"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();

export { app, auth };
